import { paths } from 'src/routes/paths';

export const { BASE_URL } = import.meta.env;
export const { API_URL } = import.meta.env;
export const { SENTRY_DSN } = import.meta.env;
export const { ASSETS_API_URL } = import.meta.env;

// After login, land on the logged-in home
export const PATH_AFTER_LOGIN = paths.app.root;
// You can set a dedicated landing page if needed in the future:
// export const PATH_LANDING = paths.welcome;
